module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_SL-729042394e4594f82d93686cea06212a.svg";